import React, { useState } from 'react';
import styled from 'styled-components';

import { v4 as uuidv4 } from 'uuid';
import { Command, tabActions } from '@store/slices';
import { AddOutlined } from '@mui/icons-material';
import { ConditionGroup } from './ConditionGroup';
import { Button } from '@common/Button';
import { useDispatch } from 'react-redux';
import { NodeConditionGroup, NodeField } from '@components/Flow/Nodes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 18px;
`;

interface Props {
  command: Command;
  field: NodeField;
}

export const LogicSwitch: React.FC<Props> = ({ command, field }) => {
  const dispatch = useDispatch();
  const condition_groups: NodeConditionGroup[] = command.state.condition_groups || [];

  const [editing, setEditing] = useState<string | null>(null);
  const [openGroups, setOpenGroups] = useState<string[]>([]);

  const addConditionGroup = () => {
    const groupId = uuidv4();

    const group = {
      id: groupId,
      name: `condition_${condition_groups.length + 1}`,
      operator: 'and',
      conditions: [
        {
          id: uuidv4(),
          input: '',
          operator: 'equals',
          value: '',
        },
      ],
    };

    const input = {
      nodeId: command.node.id,
      fieldId: field.id,
      value: group,
    };

    dispatch(tabActions.nodeInputArrayPush(input));
    dispatch(tabActions.setSaved(false));

    setOpenGroups([]);
    setEditing(groupId);
  };

  return (
    <Container>
      {condition_groups.map((conditionGroup) => {
        return (
          <ConditionGroup
            key={conditionGroup.id}
            field={field}
            command={command}
            group={conditionGroup}
            disabled={Boolean(editing && editing !== conditionGroup.id)}
            openGroups={openGroups}
            setOpenGroups={setOpenGroups}
            editing={editing === conditionGroup.id}
            setEditing={setEditing}
          />
        );
      })}
      <Button disabled={editing !== null} startIcon={<AddOutlined />} onClick={() => addConditionGroup()}>
        Add Condition Group
      </Button>
    </Container>
  );
};
